import {type LangT} from '@frontrow/console/src/entities/helpers/languages'
import {
  type FancyBody,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

/** Body of `postSchoolAdminsR`, with `language` as `LangT`. */
export type BasicSchoolAdminT = Omit<
  FancyBody<fancyOperations['postSchoolAdminsR']>,
  'language'
> & {
  language?: LangT | null
}

/** Body of `patchSchoolAdminR`, with `language` as `LangT`. */
export type SchoolAdminUpdateT = Omit<
  FancyBody<fancyOperations['patchSchoolAdminR']>,
  'language'
> & {
  language?: LangT | null
}

/** Every school-admin response is this object; it needs no conversion. */
export type DetailedSchoolAdminT = FancyOk<fancyOperations['getSchoolAdminsR']>[number]

export function mkSchoolAdminUpdate({
  old,
  updated
}: {
  old: DetailedSchoolAdminT
  updated: DetailedSchoolAdminT
}): SchoolAdminUpdateT {
  return {
    ...(old.confirmed === updated.confirmed ? {} : {confirmed: updated.confirmed}),
    ...(old.firstName === updated.firstName ? {} : {firstName: updated.firstName}),
    ...(old.lastName === updated.lastName ? {} : {lastName: updated.lastName}),
    ...(old.language === updated.language ? {} : {language: updated.language})
  }
}
